import { createContext } from 'react'

import { Style } from 'types/style'

import { StyleContextType } from './types'

const StyleContext = createContext<StyleContextType>({
  style: undefined,
  setLocalStyle: (style: Style) => {},
  fetchAndSetStyle: () => Promise.resolve(undefined),
  isLoadingStyle: true,
  getFromStorage: () => Promise.resolve(undefined),
})

export { StyleContext }
